import { featureCollection, type LineString } from '@turf/helpers';
import { useMemo } from 'react';
import { COLOR_MAP_POI, COLOR_MAP_POI_OUTLINE } from '@alltrails/denali/tokens';
import type { LineProperties } from '@alltrails/types/CustomRoute';
import { useAppSelector } from '../../../redux';
import { getSegmentPolylinesForMap } from '../../../utils/customRoutes/getSegmentPolylinesForMap';
import { PolylineSource } from '../../Polyline';
import getLineStrings from './getLineStrings';
import { UNIQUE_ID as INACTIVE_POLYLINES_UNIQUE_ID } from './InactivePolylines';

export const UNIQUE_ID = 'custom-route-polylines-saved';

const SavedRoutePolyline = () => {
  const { map, isEditing, isReplacingRoute, isToggleEnabled } = useAppSelector(state => ({
    map: state.customRoute.map,
    isEditing: state.customRoute.isEditing,
    isReplacingRoute: state.customRoute.isReplacingRoute,
    isToggleEnabled: state.map.dynamicStyleIds.includes('savedRoutePolyline')
  }));

  const data = useMemo(() => {
    if (!map) {
      return featureCollection<LineString, LineProperties>([]);
    }
    const savedSegments = getSegmentPolylinesForMap(map);
    return featureCollection<LineString, LineProperties>(
      savedSegments.flatMap((segment, index) => getLineStrings({ ...segment, color: segment.color || COLOR_MAP_POI }, undefined, index))
    );
  }, [map]);

  if (!isEditing || !map || data.features.length === 0 || (!isReplacingRoute && !isToggleEnabled)) {
    return null;
  }

  return (
    <PolylineSource
      data={data}
      uniqueId={UNIQUE_ID}
      beforeUniqueId={INACTIVE_POLYLINES_UNIQUE_ID}
      lineColor={COLOR_MAP_POI}
      lineOutlineColor={COLOR_MAP_POI_OUTLINE}
      opacity={0.6}
      hideArrows
    />
  );
};

export default SavedRoutePolyline;
